import React, { useState } from 'react';

import Titlebar from '../Titlebar';
import { BarWrapper, Content, Wrapper } from './styles';

export interface Props {
  title?: string;
  titleRight?: string;
  isOpen: boolean;
  zeroPadding?: boolean;
  children: any;
  buttons?: {
    text: string;
    width?: string;
    disabled: boolean;
    handleClick: () => void;
  }[];
}

const Collapsible = ({
  title,
  titleRight,
  isOpen,
  zeroPadding = false,
  buttons,
  children,
}: Props) => {
  const [open, setOpen] = useState(isOpen);

  return (
    <Wrapper>
      {title && (
        <BarWrapper isOpen={open}>
          <Titlebar
            title={title}
            titleRight={titleRight}
            isOpen={open}
            zeroPadding={zeroPadding}
            buttons={buttons ?? []}
            toggleClick={() => setOpen(!open)}
          />
        </BarWrapper>
      )}
      {open && <Content>{children}</Content>}
    </Wrapper>
  );
};

export default Collapsible;
